import React, { Component } from 'react';
import Datas from '../../../data/team/team-slider.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import { Styles } from "../../styles/teamSlider.js";
import { withTranslation } from 'react-i18next';

class TeamSlider extends Component {
    render() {
        const { t, i18n } = this.props;
        const translateOr = (key, fallback) => {
            const translated = t(key);
            return translated === key ? fallback : translated;
        };
        const settings = {
            slidesPerView: 3,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            spaceBetween: 30,
            watchSlidesVisibility: true,
            pagination: {
                el: '.slider-dot.text-center',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 3
                }
            }
        };

        return (
            <Styles>
                {/* Team Slider */}
                <section className="team-member-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>{translateOr('home.products.title', Datas.secTitle)}</h4>
                                </div>
                            </Col>
                            <Col md="12" className="team-slider">
                                <Swiper key={i18n.language} {...settings}>
                                    {
                                        Datas.dataList.map((data, i) => (
                                            <div className="team-item" key={i}>
                                                <Link to={process.env.PUBLIC_URL + data.productLink}>
                                                    <img src={process.env.PUBLIC_URL + `/assets/images/${data.personImage}`} alt="" className="img-fluid" />
                                                    <div className="img-content text-center">
                                                        <h5>{translateOr(`home.products.list.${i}.name`, data.personName)}</h5>
                                                        <p>{translateOr(`home.products.list.${i}.category`, data.personTitle)}</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))
                                    }
                                </Swiper>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}

export default withTranslation()(TeamSlider)